import { operators, dataOperators } from '@/assets/utils/ppob'
import store from '@/store/store'

export default {
  computed: {
    linkApp() {
      return 'https://bit.ly/zx-apps'
    } 
  },
  methods: {
    getZisLink(item) {
		  const qurbanCode = 'qurban';
		  if(item.name.toLowerCase() == qurbanCode) {
			  return '/zxcare/qurban';
		  }

		  return '/bayar-zis?ft=' + item.id + '&t=' + item.name.split(' ').map(it => it.toLowerCase()).join('_');
	  },
    createSlugLink(name, id) {
      const slug = name.split(' ')
                       .map(it => it.toLowerCase()).join(' ')
                       .replace(/\s/g, '-')
                       .replace(/[^\w-]+/g, ''),
            base64Id = this.toBase64(id + '')

      return slug + '-' + base64Id
    },
    toBase64(str) {
      return Buffer.from(str).toString('base64')
    },
    checkVerifyAccount() {
      if( store.state.auth.profile ) {
        if(!this.requiredVerifyAccount(this.$route)) {
          this.$vs.dialog({
            color: 'warning',
            title: `Akun anda belum diverifikasi`,
            text: 'Harap lakukan verifikasi akun terlebih dahulu',
            'accept-text': 'Ok',
            accept: this.acceptAlert,
            close: this.acceptAlert
          })
        }
      }
    },
    acceptAlert() {
      this.$router.push('/profile')
    },
    requiredVerifyAccount(route) {
      // if(route.meta)
      if(route.meta.verifyAccountRequired) {
        // check
        if(store.getters['auth/profile'].status == 0) {
          return false
        }

        return true
      }

      return true
    },
    replaceText(txt) {
      if(!txt) {
        return;
      }

      return txt.replaceAll("&lt;p&gt;", "")
      .replaceAll("&amp;", "&")
      .replaceAll("&amp;amp;quot;", "\"")
      .replaceAll("&quot;", "\"")
      .replaceAll("&amp;amp;amp;quot;", "")
      .replaceAll('&amp;amp;lt;', '<')
      .replaceAll('&amp;amp;gt;', '>')
      .replaceAll("&lt;", "<")
      .replaceAll("&amp;lt;", "<")
      .replaceAll("&amp;gt;", ">")
      .replaceAll("&amp;quot;", "\"")
      .replaceAll("&gt;", ">")
      .replaceAll("\"\"", "\"")
      .replaceAll("&#039;", "");
    },
    replaceAll (target, search, replaceTo) {
      return target.split(search).join(replaceTo)
    },
    truncateString(str, num) {
      if(str) {
        if(str.length && str.length <= num) {
          return str;
        }

        return str.slice(0, num) + '...';
      }

      return str;
    },
    getOperator (number) {
      const findOperator = operators.find(it => {
        return it.numbers.find(num => num == number)
      })

      return findOperator
    },
    getDataOperator (number) {
      const findOperator = dataOperators.find(it => {
        return it.numbers.find(num => num == number)
      })

      return findOperator
    },
    genNumBetween (min, max) {
		    return Math.floor(Math.random() * (max - min + 1) + min)
    },
    formatRupiah (angka, prefix = undefined) {
      if (angka) {
        let number_string = angka.toString().replace(/[^,\d]/g, '').toString(),
          split   		= number_string.split(','),
          sisa     		= split[0].length % 3,
          rupiah     		= split[0].substr(0, sisa),
          ribuan     		= split[0].substr(sisa).match(/\d{3}/gi),
          separator = ''
	 
        // tambahkan titik jika yang di input sudah menjadi angka ribuan
        if (ribuan) {
          separator = sisa ? '.' : ''
          rupiah += separator + ribuan.join('.')
        }
	 
        rupiah = split[1] != undefined ? `${rupiah  },${  split[1]}` : rupiah
        return prefix == undefined ? rupiah : (rupiah ? `Rp. ${  rupiah}` : '')
      }
			
      return angka
    },
    decodeEntities (text) {
      const span = document.createElement('span')

		    return text
		    .replace(/&[#A-Za-z0-9]+;/gi, (entity, position, text) => {
		        span.innerHTML = entity
		        return span.innerText
		    })
    },
    capitalize (s) {
      if (typeof s !== 'string') return ''
  			return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
    },
    showError(e, time = null) {
      if (e.response) 
        console.error(e.response)
        if(typeof e.response.data === 'object') {

          if(e.response.data.message) {
            const options = {
              title: 'Oops',
              text: e.response.data.message,
              color: 'danger',
              position: 'top-right'
            }

            if(time !== null) {
              options.time = time
            }
            this.$vs.notify(options)
          }
          else {
            for(let err in e.response.data) {
              const options = {
                title: 'Oops',
                text: e.response.data[err],
                color: 'danger',
                position: 'top-right'
              }

              if(time !== null) {
                options.time = time
              }
              this.$vs.notify(options)
            }
          }
            

          return false
        }
        else {
          const options = {
            title: 'Oops',
            text: e.data.message,
            color: 'danger',
            position: 'top-right'
          }

          if(time !== null) {
            options.time = time
          }
          this.$vs.notify(options)

          return false
        }
    }
  }
}
